export enum RequestStatus {
  Pending = 'pending',
  Rejected = 'rejected',
  Fulfilled = 'fulfilled',
  Idle = 'idle',
}
